export default "__VITE_ASSET__B$x6cDdq__"